// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"43390174","239":"7d21cb63","455":"d53dd744","867":"8bb6998a"}[chunkId] + ".chunk.js";
};